import React from 'react';
import CtClientTable from './table/CtClientTable';

const ClientContent: React.FC = () => {
  return <CtClientTable />;
};

export default ClientContent;
